import React from 'react';
import { StrictModeDroppable } from '@/components/DispatchPlan/stops/StrictModeDroppable';
import { ITEM_DRAG_TYPE } from '../constants';
import { Cards, Column } from './blocks';

/**
 * A board column that cards can be dropped on: item cards by default, or service cards when `type` is
 * `SERVICE_DRAG_TYPE`. It highlights while a card is over it. `header` and `footer`
 * sit above and below the cards; other props go to `Column` (for example `tray`, `clear`, `aria-label`).
 * Renders nothing on the first frame, like every `StrictModeDroppable`.
 *
 * @param {{ droppableId: string, type?: string, header: React.ReactNode, footer?: React.ReactNode, disabled?: boolean, children?: React.ReactNode }} props
 *   `droppableId` is `TRAY_DROPPABLE_ID` for the tray or the column's layout key. `type` is the drag type it accepts
 *   (`ITEM_DRAG_TYPE` or `SERVICE_DRAG_TYPE`). `disabled` stops drops.
 */
export const DropColumn = ({
    droppableId,
    type = ITEM_DRAG_TYPE,
    header,
    footer = null,
    disabled = false,
    children,
    ...columnProps
}) => (
    <StrictModeDroppable droppableId={droppableId} type={type} isDropDisabled={disabled}>
        {(provided, snapshot) => (
            <Column
                ref={provided.innerRef}
                {...provided.droppableProps}
                over={snapshot.isDraggingOver}
                {...columnProps}
            >
                {header}
                <Cards>
                    {children}
                    {provided.placeholder}
                </Cards>
                {footer}
            </Column>
        )}
    </StrictModeDroppable>
);

export default DropColumn;
